export const LUPP_BASE_URL = import.meta.env.VITE_LUPP_BASE_URL;

export const LUPP_QUERY_KEYS = {
  LEADS: 'lupp-leads',
  PROSPECTS: 'lupp-prospects',
  PROSPECTS_EXPORT_HISTORY: 'lupp-prospects-export-history',
  QUOTES: 'lupp-quotes',
  FHM_ALERTS: 'lupp-fhm-alerts',
  FHM_ALERT_DETAIL: 'lupp-fhm-alert-detail',
  FSE_TECH_SUPPORT_CASES: 'lupp-fse-tech-support-cases',
  CUSTOMER_CASES: 'lupp-customer-cases',
  NOTES: 'lupp-notes',
  PARTNER_USERS: 'lupp-partner-users',
  // FileHub keys
  FILES: 'lupp-files',
  FILE_METADATA: 'lupp-file-metadata',
  FILE_DOWNLOAD: 'lupp-file-download',
  // Inventory keys
  INVENTORY_VEHICLES: 'lupp-inventory-vehicles',
  VEHICLE_SEARCH: 'lupp-vehicle-search',
  USER_LOCATION: 'lupp-user-location',
  PR_CODES: 'lupp-pr-codes',
  USER_IDENTITY: 'lupp-user-identity',
  // Order Hub keys
  ORDERS: 'lupp-orders',
  ORDER_DETAILS: 'lupp-order-details',
  PROFORMA_INVOICES: 'lupp-proforma-invoices',
  RETAIL_DELIVERY: 'lupp-order-retail-delivery',
  FINAL_INVOICES: 'lupp-final-invoices',
  DELIVERY_ACCEPTANCE: 'lupp-delivery-acceptance',
  SERVICE_CENTERS: 'lupp-service-centers',
  // D&B Search keys
  DUNS_SEARCH: 'lupp-duns-search',
  PARTS: 'lupp-parts',
};
